export default __webpack_public_path__ + "static/media/assess-walk-2.a6a8e3ce.gif";